import { Chip as MuiChip } from '@mui/material';
import type { ChipProps as MuiChipProps } from '@mui/material/Chip';
import type { ReactElement } from 'react';

export type RawChipProps = MuiChipProps;

export const RawChip = ({ sx, ...rest }: RawChipProps): ReactElement => {
  const mergedSx = Array.isArray(sx) ? sx : sx ? [sx] : undefined;
  return <MuiChip sx={mergedSx} {...rest} />;
};
